import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'deepValue',
    standalone: true
})
export class DeepValuePipe implements PipeTransform {

    transform(value: any, path: string): any {
        if (!value || !path) return null;

        return path
            .split('.')
            .reduce((acc, key) => acc?.[key], value);
    }
}
